import { Component } from "react"
import PropTypes from "prop-types"
import DropdownServiceSelector from "shared/components/dropdown_service_selector"
import SectionHeader from "./section_header"
import EditIcon from "shared/components/icons/edit_icon"
import EncircledXIcon from "shared/components/icons/encircled_x_icon"
import capitalize from "lodash/capitalize"

export default class TandaComposer extends Component {
  constructor(props) {
    super(props)
    this.onTandaChange = this.onTandaChange.bind(this)
    this.onRemoveTandaClick = this.onRemoveTandaClick.bind(this)
  }

  componentDidUpdate(prevProps) {
    // If we just finished loading the selected service's list of triggers or
    // actions, and the user didn't explicitly focus somewhere else, focus the
    // dropdown.
    if (
      !prevProps.selectedServiceTandas &&
      this.props.selectedServiceTandas &&
      (!document.activeElement || document.activeElement === document.body)
    ) {
      this.tandasSelectRef.focus()
    }
  }

  onTandaChange(e) {
    const { selectedServiceTandas } = this.props

    if (selectedServiceTandas) {
      this.props.onTandaSelect({
        ...selectedServiceTandas.find(t => t.module_name === e.target.value),
        collapsed: false,
      })
    }
  }

  onRemoveTandaClick(e, tandaType) {
    e.preventDefault()

    this.confirmTandaRemove(tandaType) && this.props.onRemoveTanda()
  }

  tandasSelect() {
    const {
      enabled,
      selectedService,
      selectedServiceTandas,
      selectedTanda,
      tandaType,
      configUI,
    } = this.props

    let options = []

    if (selectedServiceTandas) {
      if (configUI) {
        const tandasByService = selectedServiceTandas.reduce(
          (acc, cur) => ({
            ...acc,
            [cur.channel_name]: (acc[cur.channel_name] || []).concat(cur),
          }),
          {}
        )
        options = Object.keys(tandasByService).map((service, i) => (
          <optgroup label={service} key={i}>
            {tandasByService[service].map(t => (
              <option key={t.module_name} value={t.module_name}>
                {t.name}
              </option>
            ))}
          </optgroup>
        ))
      } else {
        options = selectedServiceTandas.map(t => (
          <option key={t.module_name} value={t.module_name}>
            {t.name}
          </option>
        ))
      }

      if (!selectedTanda) {
        options.unshift(
          <option key="none" value="none">
            {`Please select ${
              tandaType === "action" ? "an" : "a"
            } ${tandaType}`}
          </option>
        )
      }
    } else if (selectedService) {
      options = [<option key="none">Loading…</option>]
    } else {
      options = [<option key="none">Please select a service above…</option>]
    }

    return (
      <select
        disabled={!enabled || !selectedServiceTandas}
        value={(selectedTanda && selectedTanda.module_name) || ""}
        onChange={this.onTandaChange}
        ref={r => (this.tandasSelectRef = r)}
      >
        {options}
      </select>
    )
  }

  confirmTandaRemove(tandaType) {
    if (!this.props.selectedTanda) return true

    return confirm(`Are you sure you want to remove this ${tandaType}?`)
  }

  renderHeaderAction() {
    const { enabled, tandaType, appletType, selectedService } = this.props

    if (!enabled) {
      return
    }

    if (tandaType === "trigger" && !selectedService) {
      return
    }

    return (
      <a
        onClick={e => this.onRemoveTandaClick(e, tandaType)}
        className="partners-tanda-composer-edit-link"
      >
        {tandaType === "trigger" && appletType === "static" ? (
          <span>
            <EditIcon /> Change service
          </span>
        ) : (
          <span>
            <EncircledXIcon />
            {` Remove ${tandaType}`}
          </span>
        )}
      </a>
    )
  }

  render() {
    const {
      children,
      contextChannelId,
      note,
      onServiceSelect,
      selectedService,
      selectedTanda,
      services,
      tandaType,
      required,
      configUI,
    } = this.props

    return (
      <div className="partners-tanda-composer field">
        <SectionHeader
          title={`${capitalize(tandaType)}${!required ? " (optional)" : ""}`}
          note={note}
          actions={this.renderHeaderAction()}
        />

        <div className="partners-tanda-composer-selectors">
          {!configUI && (
            <DropdownServiceSelector
              services={services}
              onSelect={onServiceSelect}
              selectedService={selectedService}
            />
          )}
          {selectedService && (
            <>
              <div className="partners-tanda-composer-tanda-selector input">
                {this.tandasSelect()}
              </div>
            </>
          )}

          {selectedTanda && <p className="note">{selectedTanda.description}</p>}
        </div>

        {selectedTanda && children}
      </div>
    )
  }
}

TandaComposer.propTypes = {
  contextChannelId: PropTypes.string,

  services: PropTypes.arrayOf(
    PropTypes.shape({
      module_name: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,

  selectedService: PropTypes.shape({
    id: PropTypes.string,
    module_name: PropTypes.string,
    name: PropTypes.string,
    brand_color: PropTypes.string,
    lrg_variant_image_url: PropTypes.string,
    actions: PropTypes.array,
    triggers: PropTypes.array,
  }),

  selectedServiceTandas: PropTypes.array,

  selectedTanda: PropTypes.shape({
    module_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  }),

  onServiceSelect: PropTypes.func.isRequired,
  onTandaSelect: PropTypes.func.isRequired,

  onRemoveTanda: PropTypes.func,

  tandaType: PropTypes.oneOf(["trigger", "query", "action"]),
  appletType: PropTypes.oneOf(["static", "dynamic"]),
  enabled: PropTypes.bool.isRequired,

  children: PropTypes.element,
  note: PropTypes.node,
  required: PropTypes.bool,
  configUI: PropTypes.bool,
}

TandaComposer.defaultProps = {
  appletType: "static",
  required: true,
  configUI: false,
}
